import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import React, { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import MorePopover from "./MorePopover";
import UserActions from "./UserActions";
import TemplateRound from "./TemplateRound";
import "../../../../../styles/coachup.scss";

function UsersTable({ payload, setPayload, users, count }) {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));
  const navigate = useNavigate();
  const [moreItems, setMoreItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openStatus, setOpenStatus] = useState(false);

  const REPORT_ICON_COUNT = 5;

  const handleClick = (event, index, key) => {
    setAnchorEl(event.currentTarget);
    let itemsArray = [];
    if (key === "CoachupReports") {
      itemsArray = users?.[index]?.[key].map((item) => ({
        color: item.CoachupTemplate.color,
        name: item.CoachupTemplate.name,
      }));
    } else {
      itemsArray = users?.[index]?.[key].map((item) => ({
        color: item?.CoachupTemplate?.color,
        name: item?.CoachupTemplate?.name,
      }));
    }
    setMoreItems(itemsArray?.slice(2));
  };

  const handleClose = () => {
    setAnchorEl();
    setTimeout(() => setOpenStatus(false), 150);
    // setOpenStatus(false);
  };

  const handlePageChange = (_, newPage) => {
    setPayload((prevPayload) => ({ ...prevPayload, pageNumber: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prevPayload) => ({
      ...prevPayload,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const filterReports = (reports, statuses = ["Ready For Review"]) =>
    reports.filter((report) => statuses.includes(report.statusId));

  return (
    <MDBox sx={{ position: "relative" }}>
      <TableContainer component={Paper} className="coachup-datatable">
        <Table aria-label="simple table">
          {!isMobileDisplay && (
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow className="user-table-header">
                <TableCell sx={{ minWidth: "100px" }}>Name</TableCell>
                <TableCell align="center">Role</TableCell>
                <TableCell align="center">Assigned Templates</TableCell>
                <TableCell align="center">Ready To Review</TableCell>
                <TableCell width="80px" />
                <TableCell width="80px" />
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {users?.map((row, index) => (
              <TableRow
                key={row.id}
                hover
                onClick={() => !isMobileDisplay && navigate(`/coach/reports/user/${row.id}`)}
              >
                {isMobileDisplay ? (
                  <>
                    <TableCell>
                      <Stack direction="column">
                        <Typography>{row.name}</Typography>
                        <Box className="datatable-box" alignItems="baseline">
                          <Typography className="datatable-mobile-label" width="60px">
                            Role
                          </Typography>
                          <Typography className="datatable-mobile-value">
                            {row?.UserRole?.role}
                          </Typography>
                        </Box>
                        <Box className="datatable-box" alignItems="center">
                          <Typography className="datatable-mobile-label" width="60px">
                            Assigned
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                            alignItems="center"
                          >
                            {(row?.userTemplatesId || [])
                              .slice(0, REPORT_ICON_COUNT)
                              .map((template) => (
                                <TemplateRound
                                  key={template?.CoachupTemplate?.id}
                                  title={template?.CoachupTemplate?.name}
                                  color={template?.CoachupTemplate?.color}
                                  diameter="20px"
                                />
                              ))}
                            {row?.userTemplatesId?.length > REPORT_ICON_COUNT && (
                              <Tooltip title="Click to view other templates">
                                <MDBox
                                  sx={{ marginLeft: "16px !important" }}
                                  onClick={(event) => handleClick(event, index, "userTemplatesId")}
                                  id={`view-templates-eyebox-${index}`}
                                >
                                  <MoreHorizIcon sx={{ cursor: "pointer" }} />
                                </MDBox>
                              </Tooltip>
                            )}
                          </Stack>
                        </Box>
                        <Box className="datatable-box" alignItems="center">
                          <Typography className="datatable-mobile-label" width="60px">
                            Ready
                          </Typography>

                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                            alignItems="center"
                          >
                            {(filterReports(row?.CoachupReports) || [])
                              .slice(0, REPORT_ICON_COUNT)
                              .map((report) => (
                                <TemplateRound
                                  key={report.id}
                                  title={report?.CoachupTemplate?.name}
                                  color={report?.CoachupTemplate?.color}
                                  open
                                  diameter="20px"
                                />
                              ))}
                            {filterReports(row?.CoachupReports).length > REPORT_ICON_COUNT && (
                              <Tooltip title="Click to view other reports">
                                <MDBox
                                  sx={{ marginLeft: "16px !important" }}
                                  onClick={(event) => {
                                    setOpenStatus(true);
                                    handleClick(event, index, "CoachupReports");
                                  }}
                                >
                                  <MoreHorizIcon sx={{ cursor: "pointer" }} />
                                </MDBox>
                              </Tooltip>
                            )}
                          </Stack>
                        </Box>
                      </Stack>
                    </TableCell>
                    <TableCell width="40px">
                      <Stack>
                        <UserActions user={row} />
                        {row?.CoachupReports.find(
                          (report) =>
                            report.statusId === "Ready For Review" || report.statusId === "Close"
                        ) && (
                          <Tooltip title="Click to view the user reports">
                            <MDBox
                              sx={{
                                display: "flex",
                                cursor: "pointer",
                                pt: 2,
                                fontSize: "1.25rem",
                              }}
                              onClick={() => navigate(`/coach/reports/user/${row.id}`)}
                              id={`view-reports-eyebox-${row.id}`}
                            >
                              <VisibilityIcon />
                            </MDBox>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                  </>
                ) : (
                  <>
                    <TableCell>{row.name}</TableCell>
                    <TableCell align="center">{row?.UserRole?.role}</TableCell>
                    <TableCell align="center">
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {(row?.userTemplatesId || [])
                          .slice(0, REPORT_ICON_COUNT)
                          .map((template) => (
                            <TemplateRound
                              key={template?.CoachupTemplate?.id}
                              title={template?.CoachupTemplate?.name}
                              color={template?.CoachupTemplate?.color}
                            />
                          ))}
                        {row?.userTemplatesId?.length > REPORT_ICON_COUNT && (
                          <Tooltip title="Click to view other templates">
                            <MDBox
                              sx={{ marginLeft: "16px !important" }}
                              onClick={(event) => handleClick(event, index, "userTemplatesId")}
                              id={`view-templates-eyebox-${index}`}
                            >
                              <MoreHorizIcon sx={{ cursor: "pointer" }} />
                            </MDBox>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        {(filterReports(row?.CoachupReports) || [])
                          .slice(0, REPORT_ICON_COUNT)
                          .map((report) => (
                            <TemplateRound
                              key={report.id}
                              title={report?.CoachupTemplate?.name}
                              color={report?.CoachupTemplate?.color}
                              open
                            />
                          ))}
                        {filterReports(row?.CoachupReports).length > REPORT_ICON_COUNT && (
                          <Tooltip title="Click to view other reports">
                            <MDBox
                              sx={{ marginLeft: "16px !important" }}
                              onClick={(event) => {
                                setOpenStatus(true);
                                handleClick(event, index, "CoachupReports");
                              }}
                            >
                              <MoreHorizIcon sx={{ cursor: "pointer" }} />
                            </MDBox>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <UserActions user={row} />
                    </TableCell>
                    <TableCell>
                      {row?.CoachupReports.find(
                        (report) =>
                          report.statusId === "Ready For Review" || report.statusId === "Close"
                      ) ? (
                        <Tooltip title="Click to view the user reports">
                          <MDBox
                            sx={{ display: "flex", cursor: "pointer", fontSize: "1.25rem" }}
                            onClick={() => navigate(`/coach/reports/user/${row.id}`)}
                            id={`view-reports-eyebox-${row.id}`}
                          >
                            <VisibilityIcon />
                          </MDBox>
                        </Tooltip>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 25, 50]}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          count={count}
          rowsPerPage={payload?.pageSize}
          page={payload?.pageNumber}
          sx={{ flex: "1 1 auto" }}
        />
      </TableContainer>
      <MorePopover
        items={moreItems}
        anchorEl={anchorEl}
        handleClose={handleClose}
        isOpen={openStatus}
      />
    </MDBox>
  );
}

export default UsersTable;
